import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class FeedbackService {
  sendFeedback = body => {
    return fetch(config.config.endpointUrls.sendFeedback(), {
      method: 'POST',
      body
    })
  }

  fetchFeedbackTypes = () => {
    return fetch(config.config.endpointUrls.fetchFeedbackTypes(), {
      method: 'GET'
    })
  }
}

export default new FeedbackService()



// WEBPACK FOOTER //
// ../src/services/feedbackService/feedbackService.js